import React, { useEffect, useMemo } from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Actions,
  ListItemSecondaryAction,
  Action,
  EditIcon,
  DeleteIcon,
  Box,
  makeStyles,
  Typography,
} from '@gogame/components';

import { useDeleteChat, useUpdateChat } from 'scenes/AIChatbot/data/mutations';

import { useGroupData } from './useGroupData';

const useStyles = makeStyles(() => ({
  root: {
    overflowY: 'scroll',
  },
  list: {
    paddingInline: '0 0',
    '& .secondaryAction': {
      visibility: 'hidden',
    },
    '& .MuiListItem-container:hover .secondaryAction': {
      visibility: 'visible',
    },
  },
}));

export const ChatList = ({ currentChatId, data, onSelectChat }) => {
  const classes = useStyles();
  const [deleteChat] = useDeleteChat();
  const [updateChat] = useUpdateChat();
  const getGroupData = useGroupData();

  const groupedData = useMemo(() => getGroupData(data), [data]);

  const handleUpdate = async (e, entity) => {
    e.preventDefault();
    await updateChat(entity);
  };

  const handleDelete = async (e, entity) => {
    e.preventDefault();
    await deleteChat(entity);
  };

  useEffect(() => {
    document.body
      .querySelector(`[data-cy="ListItem"][alt="${currentChatId}"]`)
      ?.scrollIntoView({
        behavior: 'instant',
        block: 'center',
      });
  }, [currentChatId, data]);

  return (
    <Box component={'section'} className={classes.root}>
      <List className={classes.list}>
        {groupedData.map((group) => {
          const isLastGroup = group === groupedData[groupedData.length - 1];
          return (
            <React.Fragment key={group.group}>
              <ListSubheader
                sx={{
                  height: 24,
                  bgcolor: 'transparent',
                  position: 'relative',
                }}
              >
                <Typography variant={'caption'} color={'textSecondary'}>
                  {group.group}
                </Typography>
              </ListSubheader>
              {group.items.map((item, itemIndex) => {
                const isActive = `${item.id}` === `${currentChatId}`;
                const isLastItem = itemIndex === group.items.length - 1;
                return (
                  <ListItem
                    sx={{
                      marginBottom: isLastItem && !isLastGroup ? 2 : 0,
                    }}
                    onClick={() => onSelectChat(item.id)}
                    button={true}
                    key={item.id}
                    selected={isActive}
                    data-cy="ListItem"
                    alt={item.id}
                  >
                    <ListItemText primary={item.name || 'Chat #' + item.id} />
                    <ListItemSecondaryAction className={'secondaryAction'}>
                      <Actions>
                        <Action
                          icon={<EditIcon />}
                          label={'Edit'}
                          onClick={(e) => handleUpdate(e, item)}
                        />
                        <Action
                          icon={<DeleteIcon />}
                          label={'Delete'}
                          onClick={(e) => handleDelete(e, item)}
                        />
                      </Actions>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </React.Fragment>
          );
        })}
      </List>
    </Box>
  );
};
